// Sound effects using Web Audio API (no external files needed)

class SoundManager {
  constructor() {
    this.audioContext = null;
    this.enabled = true;
  }

  init() {
    if (!this.audioContext) {
      this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
    }
    return this;
  }

  setEnabled(enabled) {
    this.enabled = enabled;
  }

  // Generate a simple tone
  playTone(frequency, duration, type = 'sine', volume = 0.3) {
    if (!this.enabled || !this.audioContext) return;
    
    const oscillator = this.audioContext.createOscillator();
    const gainNode = this.audioContext.createGain();
    
    oscillator.connect(gainNode);
    gainNode.connect(this.audioContext.destination);
    
    oscillator.frequency.value = frequency;
    oscillator.type = type;
    
    gainNode.gain.setValueAtTime(volume, this.audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, this.audioContext.currentTime + duration);
    
    oscillator.start(this.audioContext.currentTime);
    oscillator.stop(this.audioContext.currentTime + duration);
  }

  // Correct answer - happy ding
  playCorrect() {
    if (!this.enabled) return;
    this.init();
    
    // Play two ascending notes (happy sound)
    this.playTone(523.25, 0.1, 'sine', 0.3); // C5
    setTimeout(() => this.playTone(659.25, 0.15, 'sine', 0.3), 100); // E5
    setTimeout(() => this.playTone(783.99, 0.2, 'sine', 0.3), 200); // G5
  }

  // Wrong answer - gentle buzz
  playWrong() {
    if (!this.enabled) return;
    this.init();
    
    // Play two descending notes (sad sound)
    this.playTone(300, 0.15, 'triangle', 0.2);
    setTimeout(() => this.playTone(250, 0.2, 'triangle', 0.2), 150);
  }

  // Victory fanfare
  playVictory() {
    if (!this.enabled) return;
    this.init();
    
    // Triumphant melody
    const notes = [
      { freq: 523.25, delay: 0 },     // C5
      { freq: 523.25, delay: 150 },   // C5
      { freq: 523.25, delay: 300 },   // C5
      { freq: 523.25, delay: 450 },   // C5
      { freq: 415.30, delay: 600 },   // Ab4
      { freq: 466.16, delay: 750 },   // Bb4
      { freq: 523.25, delay: 900 },   // C5
      { freq: 466.16, delay: 1000 },  // Bb4
      { freq: 523.25, delay: 1100 },  // C5
    ];
    
    notes.forEach(note => {
      setTimeout(() => this.playTone(note.freq, 0.15, 'sine', 0.3), note.delay);
    });
  }

  // Coins collected
  playCoins() {
    if (!this.enabled) return;
    this.init();
    
    // Coin jingle
    for (let i = 0; i < 5; i++) {
      setTimeout(() => {
        this.playTone(1200 + i * 100, 0.08, 'sine', 0.15);
      }, i * 50);
    }
  }

  // Medal earned
  playMedal() {
    if (!this.enabled) return;
    this.init();
    
    // Shimmering sound
    const notes = [783.99, 987.77, 1174.66, 1318.51]; // G5, B5, D6, E6
    notes.forEach((freq, i) => {
      setTimeout(() => this.playTone(freq, 0.2, 'sine', 0.2), i * 100);
    });
  }

  // Button click
  playClick() {
    if (!this.enabled) return;
    this.init();
    this.playTone(800, 0.05, 'sine', 0.1);
  }

  // Game complete
  playComplete() {
    if (!this.enabled) return;
    this.init();
    
    // Play coins then victory
    this.playCoins();
    setTimeout(() => this.playVictory(), 300);
  }

  // Level up / achievement
  playLevelUp() {
    if (!this.enabled) return;
    this.init();
    
    const notes = [261.63, 329.63, 392.00, 523.25, 659.25, 783.99];
    notes.forEach((freq, i) => {
      setTimeout(() => this.playTone(freq, 0.12, 'sine', 0.25), i * 80);
    });
  }

  // Penalty warning
  playWarning() {
    if (!this.enabled) return;
    this.init();
    
    this.playTone(200, 0.3, 'sawtooth', 0.15);
    setTimeout(() => this.playTone(180, 0.3, 'sawtooth', 0.15), 350);
  }
}

// Create singleton instance
const soundManager = new SoundManager();

export default soundManager;
